import {Head, Seo as HydrogenSeo} from '@shopify/hydrogen';
import {useI18n} from '../contexts/I18n.client';
import {activeLanguages} from 'config/languages';
import ogImage from '../assets/og-image.png';

export const Seo = () => {
  const {t, language} = useI18n();

  return (
    <>
      {/* @ts-expect-error: Hydrogen docs also ignore errors here */}
      <HydrogenSeo
        type="defaultSeo"
        data={{
          title: t('seo.title'),
          description: t('seo.description'),
          lang: language as string,
        }}
      />

      <Head titleTemplate="%s">
        <meta property="og:image" content={ogImage} />
        <meta name="twitter:image" content={ogImage} />

        <link
          rel="alternate"
          href={`https://linkpop.com`}
          hrefLang="x-default"
        />
        {activeLanguages.map((lang) => (
          <link
            key={lang}
            rel="alternate"
            href={`https://linkpop.com/${lang}`}
            hrefLang={lang}
          />
        ))}
      </Head>
    </>
  );
};
